import { defineMessages } from 'react-intl';

export default defineMessages({
  notValidVideo: {
    id: 'app.containers.Video.VimeoUploader.notValidVideo',
    defaultMessage: 'O arquivo não é um vídeo válido',
  },
  fileIsNotAVideo: {
    id: 'app.containers.Video.VimeoUploader.fileIsNotAVideo',
    defaultMessage: 'O arquivo precisa ser um vídeo',
  },
  wrongAspectRatio: {
    id: 'app.containers.Video.VimeoUploader.wrongAspectRatio',
    defaultMessage: 'O aspect ratio do vídeo precisa estar em 3:2',
  },
  notInHorizontalError: {
    id: 'app.containers.Video.VimeoUploader.notInHorizontalError',
    defaultMessage: 'O vídeo precisa estar na horizontal',
  },
  minWidthError: {
    id: 'app.containers.Video.VimeoUploader.minWidthError',
    defaultMessage: 'A largura do vídeo precisa ser maior que 1152px',
  },
  unexpectedVideoError: {
    id: 'app.containers.Video.VimeoUploader.unexpectedVideoError',
    defaultMessage: 'Ocorreu um erro inesperado',
  },
  moveVideoHere: {
    id: 'app.containers.Video.VimeoUploader.moveVideoHere',
    defaultMessage: 'Arraste seu vídeo aqui',
  },
  videoSubtitle: {
    id: 'app.containers.Video.VimeoUploader.videoSubtitle',
    // eslint-disable-next-line max-len
    defaultMessage: 'Lembre-se de gravar o vídeo na horizontal e utilizar uma largura mínima de 1152px',
  },
  videoUploadedSuccessfully: {
    id: 'app.containers.Video.VimeoUploader.videoUploadedSuccessfully',
    defaultMessage: 'Upload realizado com sucesso',
  },
  errorInUpload: {
    id: 'app.containers.Video.VimeoUploader.errorInUpload',
    defaultMessage: 'Erro ao realizar upload',
  },
  uploadingVideo: {
    id: 'app.containers.Video.VimeoUploader.uploadingVideo',
    defaultMessage: 'Realizando Upload do vídeo',
  },
  errorProcessingVideo: {
    id: 'app.containers.Video.VimeoUploader.errorProcessingVideo',
    defaultMessage: 'Ocorreu um erro ao processar o vídeo. Por favor, tente novamente.',
  },
  noFilesSelected: {
    id: 'app.containers.Video.VimeoUploader.noFilesSelected',
    defaultMessage: 'Nenhum arquivo foi selecionado',
  },
  errorUploadingTryAgain: {
    id: 'app.containers.Video.VimeoUploader.errorUploadingTryAgain',
    defaultMessage: 'Erro ao subir o arquivo, por favor tente novamente',
  },
  pollingVideo: {
    id: 'app.containers.Video.VimeoUploader.pollingVideo',
    defaultMessage: 'Realizando processamento do vídeo',
  },
  pollingVideoDescription: {
    id: 'app.containers.Video.VimeoUploader.pollingVideoDescription',
    defaultMessage: 'Seu vídeo está sendo processado e em breve estará pronto.',
  },
  errorPolling: {
    id: 'app.containers.Video.VimeoUploader.errorPolling',
    defaultMessage: 'Erro ao fazer processamento do vídeo',
  },
  errorPollingDescription: {
    id: 'app.containers.Video.VimeoUploader.errorPollingDescription',
    defaultMessage: 'Uma falha inesperada ocorreu ao processar o vídeo. Favor tente novamente.',
  },
  waitingToPoll: {
    id: 'app.containers.Video.VimeoUploader.waitingToPoll',
    defaultMessage: 'Aguardando para processar vídeo',
  },
  waitingToPollDescription: {
    id: 'app.containers.Video.VimeoUploader.waitingToPollDescription',
    defaultMessage: 'Esta etapa começará assim que o upload for concluído',
  },
});
